<template>
  <v-container fluid class="pa-6">
    <div class="d-flex justify-space-between align-center mb-1">
      <h1 class="font-weight-bold" style="font-size: 2em;">Gerenciar Pacientes</h1>
      <!-- <v-btn color="primary" dark class="font-weight-bold" style="text-transform: none;" small>
        <v-icon left>mdi-plus</v-icon>
        Novo Paciente
      </v-btn> -->
    </div>
    <v-row class="mb-6" dense>
    <v-col cols="12" md="3">
        <v-card class="pa-4" outlined>
          <div class="caption mb-1">Total</div>
          <div class="font-weight-bold" style="font-size: 2em; color: #1976d2;">
            {{ relatorio.total_pacientes }}
          </div>
        </v-card>
      </v-col>
    <v-col cols="12" md="3">
        <v-card class="pa-4" outlined>
          <div class="caption mb-1">Ativos</div>
          <div class="font-weight-bold" style="font-size: 2em; color: #43a047;">
            {{ relatorio.total_pacientes_ativos }}
          </div>
        </v-card>
      </v-col>
    <v-col cols="12" md="3">
        <v-card class="pa-4" outlined>
          <div class="caption mb-1">Inativos</div>
          <div class="font-weight-bold" style="font-size: 2em; color: #7c4dff;">
            {{ relatorio.total_pacientes_inativos }}
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-card class="pa-4" outlined>
      <div class="font-weight-bold mb-3" style="font-size: 1.2em;">Lista de Pacientes</div>
      <v-row class="mb-4" dense>
        <v-col cols="12" md="3">
          <v-select
            v-model="filtroSelecionado"
            :items="opcoesFiltro"
            label="Buscar por"
            dense
            outlined
          ></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="valorBusca"
            prepend-inner-icon="mdi-magnify"
            :placeholder="`Digite ${filtroSelecionado.toLowerCase()}`"
            dense
            outlined
            @keyup.enter="carregarPacientes"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="2">
          <v-btn color="primary" @click="carregarPacientes">Buscar</v-btn>
        </v-col>
      </v-row>
      <v-simple-table>
        <thead>
          <tr>
            <th>Nome</th>
            <th>CPF</th>
            <th>Telefone</th>
            <th>Email</th>
            <th>Status</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="pacientes.length === 0">
            <td colspan="9" class="text-center grey--text">
              Nenhum paciente encontrado
            </td>
          </tr>
          <tr v-for="(item, i) in pacientes" :key="i">
            <td><span class="font-weight-bold">{{ item.nome }}</span></td>
            <td>{{ item.cpf }}</td>
            <td>{{ item.telefone }}</td>
            <td>{{ item.email }}</td>
            <td>
              <v-chip :color="item.statusColor" dark small>{{ item.status }}</v-chip>
            </td>
            <td>
              <v-btn icon small @click="detalhes(item)">
                <v-icon color="primary">mdi-eye</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card>
      <v-pagination class="mt-5"
        v-model="pagina"
        :length="totalPaginas"
        @input="carregarPacientes(false)"
        show-first-last-page
        show-page-numbers
        :total-visible="9"
      />
    <v-dialog v-model="dialogDetalhes" max-width="900">
      <Detalhes
        v-if="pacienteSelecionado"
        :pessoa="pacienteSelecionado"
        @fechar="dialogDetalhes = false; carregarPacientes()"
        @success="showInfo"
        @erro="showError"
      />
    </v-dialog>
    <v-snackbar
        v-model="snackbar.active"
        :color="snackbar.color"
        :multi-line="snackbar.multiLine"
        :timeout="snackbar.timeout"
        :vertical="snackbar.vertical"
      >
        {{ snackbar.text }}
      </v-snackbar>
  </v-container>
</template>

<script>
import Detalhes from '@/components/dialogs/DetalhesPessoa.vue'
export default {
  components: {
    Detalhes
  },
  name: 'GerenciarPacientes',
  data() {
    return {
      pacientes: [],
      dialogDetalhes: false,
      pacienteSelecionado: null,
      relatorio:{total_pacientes:0, 
        total_pacientes_ativos:0,
        total_pacientes_inativos:0,
      },
      opcoesFiltro: ['Nome', 'Sobrenome', 'email',],
      filtroSelecionado: 'Nome',
      valorBusca: '',
      itensPorPagina: 5,
      pagina: 1,
      totalItens: 0,
      snackbar: {
        active: false,
        color: '',
        multiLine: true,
        timeout: 4000,
        vertical: true,
        text: ''
      },
    }
  },
  created() {
    this.carregarPacientes()
    this.pegarRelatorio()
  },
  computed: {
    totalPaginas() {
      return Math.ceil(this.totalItens / this.itensPorPagina)
    },
    pacientesPaginados() {
      const start = (this.pagina - 1) * this.itensPorPagina;
      const end = start + this.itensPorPagina;
      return this.pacientes.slice(start, end);
    },
  },
  methods: {
    carregarPacientes(resetPage=true) {
      if (resetPage) this.pagina = 1
      let campoFiltro = this.filtroSelecionado.toLowerCase() 
      const params = {
        tipo_usuario: 1,
        page: this.pagina,
        page_size: this.itensPorPagina
      }
      if (this.valorBusca) {
        params[campoFiltro] = this.valorBusca
      }
      this.$store.dispatch('pegarPessoas', params)
        .then(data => {
          const lista = Array.isArray(data) ? data : data.results || []
          this.pacientes = lista.map(pessoa => ({
            nome: pessoa.nome + ' ' + (pessoa.sobrenome || ''),
            cpf: pessoa.cpf,
            telefone: pessoa.telefone,
            email: pessoa.email,
            ultimaConsulta: pessoa.ultimaConsulta,
            status: pessoa.paciente && pessoa.paciente.ativo ? 'Ativo' : 'Inativo',
            statusColor: pessoa.paciente && pessoa.paciente.ativo ? 'green' : 'red darken-2',
            original: pessoa
          }))
          this.totalItens = data.count || this.pacientes.length
        })
        .catch(err => console.error(err))
    },
    pegarRelatorio() {
      this.$store.dispatch('pegarRelatorios')
        .then(data => {
          this.relatorio = data
        })
        .catch(err => {
          console.error('Erro ao pegar relatório:', err)
        })
    },
    detalhes(item) {
      this.pacienteSelecionado = item.original
      this.dialogDetalhes = true
    },
    showInfo (info) {
      this.snackbar.color = 'success'
      this.snackbar.text = info
      this.snackbar.active = true
    },
    showError (error) {
      this.snackbar.color = 'error'
      this.snackbar.text = error
      this.snackbar.active = true
    },
  }
}
</script>

<style scoped>
th, td {
  padding: 12px 8px !important;
}
.v-chip {
  font-weight: bold;
  font-size: 0.95em;
}
</style>